module.exports = __webpack_public_path__ + "assets/security-black.bba4a896.svg";